"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "garniga-terme": {
    "4b73bccf": [{
      "hkey": "41e71385",
      "slug": "garniga-terme",
      "name": "Garniga Terme",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "41e71385",
      "slug": "garniga-terme",
      "name": "Garniga Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e03cac07": [{
      "hkey": "41e71385",
      "slug": "garniga-terme",
      "name": "Garniga Terme",
      "primary": true,
      "skipSearch": false
    }],
    "zobio": [{
      "hkey": "41e71385",
      "slug": "garniga-terme",
      "name": "Garniga Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;